import featuresAndBugsTour from "./features-bugs";
import homepageTour from "./homepage";

const driver_tour = {
	close: "Are you sure you want to close the tour?",
	done: "Done",
	features_and_bugs_tour: featuresAndBugsTour,
	homepage_tour: homepageTour,
	next: "Next",
	previous: "Previous",
	title: "Driver Tour",
};
export default driver_tour;
